export const getAppConfig = async () => {
    try {
        const response = await fetch('./app-config.json');
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
    }
}